import { SagaIterator } from "redux-saga";
import { call, put, SagaGenerator, takeEvery } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { RESOURCE_KEYS } from "../../localization";
import { putErrorNotification } from "../../utilities/notificationUtils";

import { loadAssigneeCandidates, LoadAssigneeCandidatesPayload } from "../slices/users/actions";
import { setUsers } from "../slices/users/reducers";
import { isAssigneeCandidatesData } from "../slices/users/types";

import { fetchSagaFactory } from "./fetchSagaFactory";

export function* loadAssigneeCandidatesSaga(): SagaIterator<void> {
	yield* takeEvery(
		loadAssigneeCandidates,
		function* handle({ payload: { fvKey } }: Action<LoadAssigneeCandidatesPayload>): SagaGenerator<void> {
			yield* call(
				fetchSagaFactory(
					{
						method: "GET",
						relativeUrl: `/assignees?fachverfahrenKey=${fvKey}`,
						customHeaders: [["Accepts", "application/json"]]
					},
					function* handleResponse(response) {
						const assigneeCandidatesData = yield* call(response.json.bind(response));

						if (isAssigneeCandidatesData(assigneeCandidatesData)) {
							yield* put(
								setUsers({
									fvKey,
									assigneeCandidates: [...assigneeCandidatesData].sort((a, b) =>
										(a.fullName ?? a.username).localeCompare(b.fullName ?? b.username)
									)
								})
							);
						} else {
							yield* call(
								putErrorNotification,
								RESOURCE_KEYS.features.notification.error.assigneeCandidates.genericError,
								undefined,
								undefined,
								"loadAssigneeCandidatesSaga"
							);
						}
					},
					function* handleError(error) {
						yield* call(
							putErrorNotification,
							RESOURCE_KEYS.features.notification.error.assigneeCandidates.genericError,
							error,
							undefined,
							"getEnvironmentData"
						);
					}
				)
			);
		}
	);
}
